export default __webpack_public_path__ + "static/media/ep15.87d45bfd.jpeg";